import React, { useContext, useState } from "react";
import {useTranslation} from 'react-i18next'
import {
  CheckinForm,
  SubmitButton
} from "../Checkin/checkin.styles";
import { UserContext } from "../../contexts/user.context";
import {
  LoginFormContainer,
  LoginInputLabel,
  LoginTextInput,
  LoginInputWrapper,
} from "../login-guest/login-guest.styles";

const defaultFormFields = {
  email: "",
  password: "",
};


const AdminLoginForm = () => {
  const {t} = useTranslation();
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { email, password } = formFields;
  const {signInUser} = useContext(UserContext)

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await signInUser(email, password)
      resetFormFields();
    } catch (error) {
      alert("Sign in failed", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <CheckinForm onSubmit={handleSubmit}>
      <LoginFormContainer>
        <LoginInputWrapper>
          <LoginInputLabel htmlFor="email">{t('admin_email')}</LoginInputLabel>
          <LoginTextInput
            type="text"
            name="email"
            onChange={handleChange}
            value={email}
          ></LoginTextInput>
        </LoginInputWrapper>
        <LoginInputWrapper>
          <LoginInputLabel htmlFor="password">{t('admin_password')}</LoginInputLabel>
          <LoginTextInput
            type="password"
            name="password"
            onChange={handleChange}
            value={password}
          ></LoginTextInput>
        </LoginInputWrapper>
      </LoginFormContainer>
      <SubmitButton type="submit" style={{ marginTop: "100px", fontSize: '11pt', fontWeight: '800', color: '#fff'}}>
      {t('admin_login_button')}
      </SubmitButton>
    </CheckinForm>
  );
};

export default AdminLoginForm;